import { Injectable } from "@angular/core";
import { ApiServiceCall } from "../global.apiServicecall";
import { ApiUrl } from "../../constants/apiUrl";
import { JwtTokenService } from "./jwt-token.service";
import { LoginModel } from "../../models/auth/login-model";
import { Observable } from "rxjs";
import { OperationResult } from "../../models/operation-result";
import { SignUpModel } from "../../models/auth/signup-model";

@Injectable()
export class AuthService {
  constructor(
    private serviceCall: ApiServiceCall,
    private jwtTokenservice: JwtTokenService
  ) { }

  login(loginModel: LoginModel): Observable<OperationResult<any>> {
    let _url = ApiUrl.login;
    return this.serviceCall.Post(_url, false, loginModel);
  }

  signUp(signupModel: SignUpModel): Observable<OperationResult<any>> {
    let _url = ApiUrl.signup;
    return this.serviceCall.Post(_url, false, signupModel);
  }

  resendMail(user_id: any): Observable<OperationResult<any>> {
    let _url = ApiUrl.signup + "/resend_mail";
    return this.serviceCall.Post(_url, false, user_id);
  }

  loginWithGoogle(access_token: any): Observable<OperationResult<any>> {
    let _url = ApiUrl.loginWithGoogle;
    return this.serviceCall.Post(_url, false, { access_token: access_token });
  }

  loginWithApple(access_token: any): Observable<OperationResult<any>> {
    let _url = ApiUrl.loginWithApple;
    return this.serviceCall.Post(_url, false, { access_token: access_token });
  }

  activateUser(token: any) {
    let _url = ApiUrl.activate + `/${token}`;
    return this.serviceCall.GET(_url, false, null);
  }
  
  requestChangePassword(data: any) {
    let _url = ApiUrl.forgot_password;
    return this.serviceCall.Post(_url, false, data);
  }
  
  checkReturnFromRequestPassword(token: any) {
    let _url = ApiUrl.return_forgot_password + `/${token}`;
    return this.serviceCall.Post(_url, false, null);
  }

  changePassword(data: any) {
    let _url = ApiUrl.change_password;
    return this.serviceCall.Post(_url, false, data);
  }

  logout() {
    let _url = ApiUrl.logout;
    return this.serviceCall.GET(_url, true, null);
  }

  checkUserRegType(data: any) {
    let _url = ApiUrl.check_reg_type;
    return this.serviceCall.Post(_url, false, data);
  }
}